export * from './header/header.component';
export * from './sidebar/sidebar.component';
export * from './typeahead-select/typeahead-select.component';
export * from './editable-select/editable-select.component';
export * from './toggle-checkbox/toggle-checkbox.component';

export * from './shared.module';



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/components/index.ts